import { render, staticRenderFns } from "./BreachingUrbanPlanningRegulation.vue?vue&type=template&id=6dfaedc0&"
import script from "./BreachingUrbanPlanningRegulation.vue?vue&type=script&lang=ts&"
export * from "./BreachingUrbanPlanningRegulation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports